import * as React from 'react';
import { cn } from '@ais-ui/utils';

/* ------------------------------------------------------------------ */
/* Zone 1: Identity                                                    */
/* ------------------------------------------------------------------ */

export const TableDockTypeTag = ({
  className,
  ...props
}: React.ComponentProps<'span'>) => (
  <span
    className={cn(
      'flex h-[18px] items-center rounded-sm bg-muted px-1.5 text-[11px] font-medium text-muted-foreground',
      className,
    )}
    {...props}
  />
);

export const TableDockDivider = ({
  className,
  ...props
}: React.ComponentProps<'span'>) => (
  <span
    aria-hidden="true"
    className={cn('h-[18px] w-px shrink-0 bg-border', className)}
    {...props}
  />
);

export interface IdentityProps extends Omit<
  React.ComponentProps<'div'>,
  'title'
> {
  /** Leading glyph (15px, primary). Any Phosphor icon element. */
  icon?: React.ReactNode;
  /** The subject of the table ("Port of Aarhus", "Targets in view"). */
  title: React.ReactNode;
  /** What kind of table this is ("Port calls", "Report"). */
  typeTag?: React.ReactNode;
}

export const TableDockIdentity = ({
  icon,
  title,
  typeTag,
  className,
  ...props
}: IdentityProps) => (
  <div
    className={cn('flex flex-none items-center gap-2', className)}
    {...props}
  >
    {icon && (
      <span className="flex size-[15px] shrink-0 items-center justify-center text-primary [&_svg]:size-[15px]">
        {icon}
      </span>
    )}
    <span className="whitespace-nowrap text-[13px] font-semibold text-foreground">
      {title}
    </span>
    {typeTag && <TableDockTypeTag>{typeTag}</TableDockTypeTag>}
    <TableDockDivider />
  </div>
);
